import { useMemo } from 'react'
import { useOperatorSession } from '@/hooks/useOperatorSession'
import type { OperatorRole } from '@/types/api'

export interface UseRolesResult {
    roles: OperatorRole[]
    hasRole: (role: OperatorRole) => boolean
    hasAnyRole: (...roles: OperatorRole[]) => boolean
}

export function useRoles(): UseRolesResult {
    const { roles } = useOperatorSession()
    return useMemo<UseRolesResult>(() => {
        const set = new Set<OperatorRole>(roles)
        return {
            roles,
            hasRole: (role) => set.has(role),
            hasAnyRole: (...needed) => needed.some((r) => set.has(r)),
        }
    }, [roles])
}
